import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
    Input,
    Row,
    InputGroup,
    InputGroupAddon,
    Col,
    ButtonDropdown,
    DropdownMenu,
    DropdownItem,
    Label
} from "reactstrap";
import { units } from "../../../../../common/units";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { DropDownFacade } from "../../../../../components/UI/Buttons/DropDownFacade";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import Slider, { createSliderWithTooltip } from "rc-slider";
import JirangoFontPicker from "../../../../../fonts/FontPicker";
import { deepClone, setValueToNestedObject } from "../../../../../helpers/objectHelper";
import { templateHelper } from "../../helpers/templateHelper";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { FontWeightPicker } from "../../../../../fonts/FontWeightPicker/FontWeightPicker";
const SliderWithTooltip = createSliderWithTooltip(Slider);

class LabelSettings extends React.Component {
    handleUpdate = template => {
        const { dispatch } = this.props;
        dispatch(templateActions.softUpdate(template));
      };
      handleChange = (color, e, path, fallbackUnit = null) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);
        let value = templateHelper.getValueFromInput(e, color);
        let unit = templateHelper.getUnit(templateCopy, names);
        if(parseFloat(value)  && unit.length < 4){
          value += unit;
        }
        templateCopy.content = deepClone(
          setValueToNestedObject(names, value, templateCopy.content)
        );
        this.handleUpdate(templateCopy);
      };
      handleUnitChange = (unit, path) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);
        const value = templateHelper.getValueWithoutUnit(templateCopy, names);
      
        templateCopy.content = setValueToNestedObject(
          names,
          value + unit,
          templateCopy.content
        );
    
        if (unit === "auto") {
          templateCopy.content[names[0]][names[1]] = unit;
        }
        this.handleUpdate(templateCopy);
      };
      render() {
        const { template } = this.props;
        if (template === undefined) return null;
        return (
          <div style={{ paddingTop: "10px" }}>
            <Row>
              <Col className="list-setting-item-title">
                <Label>
                  <SystemLabel name="TextColor" />
                </Label>
              </Col>
              <Col className="list-setting-item-input">
                <ColorPickerFacade
                  color={template && template.content.label.color}
                  onChange={this.handleChange}
                  path="label.color"
                />
    
                <br />
              </Col>
            </Row>
            <JirangoFontPicker
              onChange={this.handleChange}
              path="label.fontFamily"
              fontWeight={template.content.label.fontWeight}
              currentFontFamily={template && template.content.label.fontFamily}
            />
            <FontWeightPicker
              onChange={this.handleChange}
              path="label.fontWeight"
              currentFont={template.content.label.fontFamily}
              weight={template.content.label.fontWeight}
            />
            <hr />
            <EditorSlider
              value={templateHelper.getValueWithoutUnit(template, "label.fontSize")}
              defaultValue={0}
              unitChange={this.handleUnitChange}
              onChange={this.handleChange}
              units={["px", "rem", "em"]}
              activeUnit={templateHelper.getUnit(template, "label.fontSize")}
              steps={1}
              max={150}
              min={1}
              path={"label.fontSize"}
              label="FontSize"
            />
            <br/>
            <EditorSlider
              value={templateHelper.getValueWithoutUnit(
                template,
                "label.letterSpacing"
              )}
              defaultValue={0}
              unitChange={this.handleUnitChange}
              onChange={this.handleChange}
              units={["px", "rem", "em"]}
              activeUnit={templateHelper.getUnit(template, "label.letterSpacing")}
              steps={1}
              max={150}
              min={1}
              path={"label.letterSpacing"}
              label="LetterSpacing"
            />
          </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        alert: state.alert,
        template: state.template.template
    };
}
export default connect(mapStateToProps)(LabelSettings);
